// Variant change
this.customVariantChangeEvent = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    console.info('%c[Variant changed]', 'color: #5fb8ff')
    console.log(event.data)
    window.VehicleSelector.checkVariant(event.data.variant);
    console.log('Check for selected variant');
    //window.checkSelectedVariant();
});

// Cart change
this.customCartChangeEvent = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    console.info('%c[Cart updated]', 'color: #5fb8ff')
    console.log(event)
  // Check for Intent
  if(window.intent && window.intent.dataLayer && event.productVariantId) {
    console.log('Product added');
    console.log(event.cartData)
      // Payload
      const payload = {
          product_name: event.cartData.title,
          product_sku: event.cartData.sku,
          product_price: event.cartData.presentment_price,
          product_brand: event.cartData.vendor,
          product_category: event.cartData.product_type
      };
      console.log(payload);

      window.intent.dataLayer.push({
        type: 'AddToCart',
        data: payload
      });
  }
});

// Cart error
this.customCartErorrEvent = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
    console.info('%c[Cart error]', 'color: #5fb8ff')
    console.log(event)
});

// Qty change
this.customQtyChangeEvent = subscribe(PUB_SUB_EVENTS.quantityUpdate, (event) => {
    console.info('%c[Quantity updated]', 'color: #5fb8ff')
    console.log(event.data)
});

// Options change
this.customOptionsChangeEvent = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
    console.info('%c[Options change]', 'color: #5fb8ff')
    console.log(event.data)
    //console.log('Check for selected variant');
    //window.checkSelectedVariant();
});